import { TicketForm, NewPostForm } from './TicketForm';
import { useLocation } from 'react-router-dom';

function ReportPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const itemSearch = params.get('itemSearch') || '';
  const category = params.get('category') as 'food' | 'sightseeing' | '';
  const itemId = Number(params.get('id')) || null;
  const autoIso = params.get('iso');
  const autoCountry = params.get('country');

  return (
    <div className="ReportPage" style={{ margin: '20px' }}>
      <div className="ticket-form-container">
        <TicketForm autoItemSearch={itemSearch} autoCategory={category || null} autoItemId={itemId} autoIso={autoIso} autoCountry={autoCountry} />

        <NewPostForm />
      </div>
    </div>
  );
}

export default ReportPage;
